import axios from '@/api/$axios'
export default {
  list ({ page, perPage, courseId }) {
    return axios.get(`/courses/${courseId}/stages`, {
      params: { page, perPage }
    })
  },
  detail ({ id }) {
    return axios.get(`/lessons/${id}`)
  }
}
